import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AsyncPipe } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { BpTryAgainErrorModule } from "@v4-components/bp-try-again-error/bp-try-again-error.module";
import { EarnConsentScreenComponent } from "@modules/staking/components/earn-consent-screen/earn-consent-screen.component";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";

export enum EarnRoutes {
	basePath = "earn",
	consent = "earn-consent"
}

const routes: Routes = [
	{
		path: EarnRoutes.consent,
		component: ModalHolderComponent,
		canActivate: [],
		data: {
			component: EarnConsentScreenComponent,
			options: {
				wrap: false,
				showPrevious: false,
				showCancel: false,
				size: ModalSizes.md,
				extraClass: ["no-gutter"],
				preserveQueryParamsOnClose: false,
				allowBackdropCancel: false
			}
		}
	}
];

@NgModule({
	declarations: [EarnConsentScreenComponent],
	imports: [AsyncPipe, CoreModule, BpTryAgainErrorModule, RouterModule.forChild(routes)],
	exports: []
})
export class EarnConsentScreenModule {}
